import styled from 'styled-components'
import { Select as AntSelect } from 'antd'
import { IStyledProps } from './interface'

interface ICustomSelectProps extends IStyledProps {
  $multiline?: boolean
}

export const Select = styled(AntSelect)<ICustomSelectProps>`
  ${props => (Number.isInteger(props?.width) ? 'width: ' + props.width + 'px;' : '')}

  background-color: #fff;

  .ant-select-selector {
    background-color: inherit!important;
  }

  ${props =>
    props.$multiline &&
    `
    &.ant-select-single {
      height: auto!important;
    }

    .ant-select-selector {
      min-height: 32px;
      height: auto!important;
      align-items: flex-start;
      padding-top: 0px!important;
      padding-bottom: 0px!important;
    }

    .ant-select-selection-item,
    .ant-select-selection-placeholder {
      white-space: normal!important;
      line-height: 20px!important;
      height: auto;
    }
  `}
`
